import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {SprintStickerState} from 'yougile-model'
import {DateRangePicker} from '@components/common/date-picker-old/date-range-picker'
import {TextInput} from '@components/common/text-input/text-input'

interface SprintStateEditProps {
  state: SprintStickerState
  onChange: (name: string) => void
  onSave: () => void
  onChangeDates: (range: [Date, Date]) => void
}

export const SprintStateEdit = (props: SprintStateEditProps) => {
  const {state, onChange, onSave, onChangeDates} = props

  useEffect(() => {
    const listener = (ev: KeyboardEvent) => {
      const eventKey = ev.key.toLocaleLowerCase()
      if (eventKey === 'enter') {
        ev.stopPropagation()
        onSave()
        focus()
      }
    }
    window.addEventListener('keydown', listener)
    return () => {
      window.removeEventListener('keydown', listener)
    }
  })

  const onChangeName = (value: string) => {
    onChange(value)
  }

  const dates =
    state.begin && state.end ? (
      <span>
        {Time.formatDate(state.begin)} - {Time.formatDate(state.end)}
      </span>
    ) : (
      <span className="sticker-edit-calendar-empty">
        {Lang.msg.chooseDates}
      </span>
    )
  const initialDates =
    state.begin && state.end
      ? ([state.begin, state.end].map(Time.toLocalDate) as [Date, Date])
      : undefined

  return (
    <div className="sticker-item-cnt" key={state.id}>
      <div className="sticker-item edit pl-6">
        <div className="flex items-center">
          <TextInput
            className="_input sticker-item-edit-text w-[150px]"
            placeholder={Lang.msg.stickerStatePlaceholder}
            value={state.name}
            onChange={onChangeName}
          />
          <span className="_link sticker-item-edit-save" onClick={onSave}>
            {Lang.msg.save}
          </span>
        </div>
        <div className="sticker-edit-calendar">
          <i className="sticker-edit-calendar-icon fa fa-calendar" />({dates})
          <DateRangePicker
            onChoose={onChangeDates}
            initialDates={initialDates}
          />
        </div>
      </div>
    </div>
  )
}
